import { AddAppointment } from '@features/schedule/ui/add-appointment/add-appointment';
import { ClassCard } from '@features/schedule/ui/class-сard/class-сard';
import { useAddAppointmentByTeacherModal } from '@features/teacher/add-appointment-by-teacher/model/use-add-appointment-by-teacher-modal';
import { calculateTimeSlotConditions } from '@widgets/schedule/lib/calculateTimeSlotConditions';
import { mergeTimeSlotsAndClasses } from '@widgets/schedule/lib/mergeTimeSlotsAndClasses';
import { removeDuplicateClassSlots } from '@widgets/schedule/lib/removeDuplicateClassSlots';
import { shouldShowTimeSlot } from '@widgets/schedule/lib/shouldShowTimeSlot';
import { sortSlotsByTime } from '@widgets/schedule/lib/sortSlotsByTime';
import React from 'react'

export const ScheduleItems = ({ dayName, weekday, weekClasses, groupedTimeSlots, isTeacher, upcoming, start_date, end_date, date, today, todayWithTime, showType}) => {
	const { open: openAddAppointmentModal } = useAddAppointmentByTeacherModal()
	
	if(!groupedTimeSlots[weekday]?.times?.length){
		return null
	}

	const mergedSlots = mergeTimeSlotsAndClasses(
    dayName, 
    weekday, 
    weekClasses, 
    groupedTimeSlots
  );
  
  const uniqueSlots = removeDuplicateClassSlots([...mergedSlots]);
  
  const sortedSlots = sortSlotsByTime(uniqueSlots);
  

  return sortedSlots.map((slot) => {
    // Рендерим класс (объект)
    if (typeof slot === 'object') {
      return (
        <ClassCard
          key={slot?.starts_at}
          isTeacher={isTeacher}
          isUpcoming={upcoming?.id === slot?.id}
          {...slot}
        />
      );
    }
    
    // Рендерим временной слот (строку)
    const { diffDays, diffMinutes } = calculateTimeSlotConditions(
      slot, 
      date, 
      today, 
      todayWithTime
    );
    
    if (!shouldShowTimeSlot(showType, diffDays, diffMinutes)) {
      return null;
    }
    
    return (
      <AddAppointment
        key={`${slot}-${date}`}
        time={slot}
        onClick={() => openAddAppointmentModal({
          date,
          time: slot,
          params: {
            from: start_date?.toISOString(),
            to: end_date?.toISOString(),
          },
        })}
      />
    );
  });
}